import axiosInstance from "../axios/axiosInstance";
import ENV from "constants/env";

const companyId = () => localStorage.getItem("companyId") || ENV.COMPANY_ID;
const unwrap = (res) => Array.isArray(res) ? res : (res?.data ?? res?.items ?? []);

export const getCompanyBenefits = async () => {
    const res = (await axiosInstance.get(`/companies/${companyId()}/benefits/company`)).data;
    return unwrap(res);
};
export const createCompanyBenefit = async (payload) => {
    return (await axiosInstance.post(`/companies/${companyId()}/benefits/company`, payload)).data;
};
export const updateCompanyBenefit = async ({ benefitId, ...payload }) => {
    return (await axiosInstance.patch(`/companies/${companyId()}/benefits/company/${benefitId}`, payload)).data;
};
export const getCompanyBenefit = async (benefitId) => {
    return (await axiosInstance.get(`/companies/${companyId()}/benefits/company/${benefitId}`)).data;
};
export const deleteCompanyBenefit = async (benefitId) => {
    return (await axiosInstance.delete(`/companies/${companyId()}/benefits/company/${benefitId}`)).data;
};
export const getEmployeeBenefits = async () => {
    const res = (await axiosInstance.get(`/companies/${companyId()}/benefits/employee`)).data;
    return unwrap(res);
};
export const createEmployeeBenefit = async (payload) => {
    return (await axiosInstance.post(`/companies/${companyId()}/benefits/employee`, payload)).data;
};
export const updateEmployeeBenefit = async ({ benefitId, ...payload }) => {
    return (await axiosInstance.patch(`/companies/${companyId()}/benefits/employee/${benefitId}`, payload)).data;
};
export const getEmployeeBenefit = async (benefitId) => {
    return (await axiosInstance.get(`/companies/${companyId()}/benefits/employee/${benefitId}`)).data;
};
export const deleteEmployeeBenefit = async (benefitId) => {
    return (await axiosInstance.delete(`/companies/${companyId()}/benefits/employee/${benefitId}`)).data;
};

